var React = require('react');

function Beer (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.5 28.5V24H28.5C30.1569 24 31.5 22.6569 31.5 21V13.5C31.5 11.8431 30.1569 10.5 28.5 10.5H25.5V7.5C25.5 5.84315 24.1569 4.5 22.5 4.5H7.5C5.84315 4.5 4.5 5.84315 4.5 7.5V28.5C4.5 30.15 5.85 31.5 7.5 31.5H22.5C24.15 31.5 25.5 30.15 25.5 28.5ZM7.5 12V7.5H22.5V12H7.5ZM7.5 15V28.5H22.5V15H7.5ZM25.5 21V13.5H28.5V21H25.5ZM13.5 24C13.5 24.8284 12.8284 25.5 12 25.5C11.1716 25.5 10.5 24.8284 10.5 24V19.5C10.5 18.6716 11.1716 18 12 18C12.8284 18 13.5 18.6716 13.5 19.5V24ZM18 25.5C18.8284 25.5 19.5 24.8284 19.5 24V19.5C19.5 18.6716 18.8284 18 18 18C17.1716 18 16.5 18.6716 16.5 19.5V24C16.5 24.8284 17.1716 25.5 18 25.5Z","fill":"#D33736"}));
}

Beer.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Beer;

Beer.default = Beer;
